import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massRestoreBlogs } from "../../api/apiBlogs";
import parseError from "../../utils/parseError";

/**
 * Hook لاستعادة جماعية للمدونات
 */
export function useRestoreAllBlogs() {
    const queryClient = useQueryClient();

    const {
        mutate: restoreAllBlogsMutate,
        isPending,
    } = useMutation({
        mutationFn: massRestoreBlogs,
        onSuccess: (response) => {
            toast.success(response.message || "Restored successfully");
            queryClient.invalidateQueries({ queryKey: ["blogs"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore blogs");
        },
    });

    return {
        restoreAllBlogsMutate,
        isPending,
    };
}
